import { GameCardBackgroundImage } from './GameCardBackgroundImage'

type Props = Readonly<{
  isLoading: boolean
  trackImage: string
  trackName: string
  videoPreviewMp4: string | null
}>

export function GameCardVisual({ trackImage, trackName, videoPreviewMp4, isLoading }: Props) {
  return (
    <div className="entry-image">
      <GameCardBackgroundImage
        trackImage={trackImage}
        trackName={trackName}
        videoPreviewMp4={videoPreviewMp4}
      />
      {Boolean(isLoading) && (
        <div className="loading-overlay">
          <div className="loading-spinner" />
        </div>
      )}
    </div>
  )
}
